import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import Modal from "react-modal";
import { X } from "lucide-react";

Modal.setAppElement("#root");

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "999",
  },
  content: {
    background: "#000F1F",
    position: "relative",
    top: "auto",
    left: "auto",
    right: "auto",
    bottom: "auto",
    width: "90%",
    padding: "20px",
    border: "1px solid #192634",
    borderRadius: "24px",
    zIndex: "999",
    overflow: "hidden",
  },
};

const ClubbieModal = ({
  isOpen,
  toggle,
  title,
  children,
  footer,
  maxHeight = "100%",
  height,
  width
}) => {
  const updatedStyles = {
    ...customStyles,
    content: {
      ...customStyles.content,
      display: "flex",
      flexDirection: "column",
      width: "90%",
      maxWidth: width || "32rem",
      maxHeight,
      ...(height && { height }),
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={toggle}
      style={updatedStyles}
      contentLabel={title}
      
    >
      <div className="flex flex-col h-full min-h-0 flex-1 ">
        {/* Header */}
        <div className="shrink-0 flex items-center justify-between mb-4">
          <h2 className="text-[18px] font-medium text-[#FEFCEB]">{title}</h2>
          <button
            className="p-1 hover:text-[#7F8585] text-[#FEFCEB] transition-colors cursor-pointer"
            onClick={toggle}
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto min-h-0 ScrollBox">
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div className="shrink-0 flex justify-end gap-2.5 pt-4">
            {footer}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ClubbieModal;
